import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
// HOCs
import withFormManagement from 'hocs/WithFormManagement';
import withMessageDialog from 'hocs/WithMessageDialog';
// Core components
import { TextButton, ContainedButton } from 'components/core/Button';
// Permissions
import permissions from 'constants/Permissions';
import OnlyWith from 'components/permissions/OnlyWith';
import AlternativeTextField from 'components/permissions/AlternativeTextField';
// Custom
import { customerDataShape, errorShape } from 'constants/PropTypesShapes';
import { sanitizeInt } from 'utils/Tools';
import { computeErrors } from 'utils/Forms';
import { ResetContainedButton } from 'components/buttons/ContainedButtons';
import ErrorsDisplayer from 'components/misc/ErrorsDisplayer';
import Callout from 'components/misc/Callout';
import NumberInputField from 'components/inputFields/NumberInputField';

class CustomerStateForm extends React.Component {
  constructor(props) {
    super(props);

    this.handleUpdate = this.handleUpdate.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { updateError, handleDisplayMessage } = this.props;
    const { updateError: prevUpdateError } = prevProps;

    // Check errors
    if (updateError && !prevUpdateError) {
      // Compute errors
      const errors = computeErrors(null, updateError);
      if (errors.global !== 'form') {
        // Display message
        handleDisplayMessage(`error.${errors.global}`, {}, 'warning');
      }
    }
  }

  // Handlers
  handleUpdate() {
    const {
      fields: {
        insideQuantity,
        outsideQuantity,
      },
      customer,
      onUpdate,
    } = this.props;
    // No specific check => validate form
    onUpdate(customer, { insideQuantity, outsideQuantity });
  }

  render() {
    const {
      fields: { insideQuantity, outsideQuantity }, errors,
      customer, onFieldsChange, onResetForm, onReinit,
    } = this.props;

    // Current inside/outside quantities
    const { state: { inside_quantity: currentInsideQuantity, outside_quantity: currentOutsideQuantity, unknown_quantity: unknownQuantity } } = customer;
    // Check if a change has been made
    const hasChanged = currentInsideQuantity !== insideQuantity || currentOutsideQuantity !== outsideQuantity;

    // Specific permsissions
    const { pInstallation: { customerWrite } } = permissions;

    return (
      <div className="box box-default m-0">
        <ErrorsDisplayer errors={errors} />
        <Callout withInfoIcon>
          <LocalizedMessage id="vehicles.state.unknownQuantity" values={{ value: unknownQuantity }} />
        </Callout>
        <div className="px-3 pb-2">
          <div className="row">
            <div className="col-12 col-md-6">
              <OnlyWith
                permissions={{
                  needed: customerWrite,
                  permissionsOrContext: 'installationPermissions',
                }}
                alternativeComponent={<AlternativeTextField fieldId="field.insideVehicles" value={insideQuantity} />}
              >
                <NumberInputField
                  label={<LocalizedMessage id="field.insideVehicles" />}
                  min={0}
                  value={insideQuantity}
                  sanitizer={sanitizeInt}
                  onChange={(value) => onFieldsChange({ insideQuantity: value })}
                />
              </OnlyWith>
            </div>
            <div className="col-12 col-md-6">
              <OnlyWith
                permissions={{
                  needed: customerWrite,
                  permissionsOrContext: 'installationPermissions',
                }}
                alternativeComponent={<AlternativeTextField fieldId="field.outsideVehicles" value={outsideQuantity} />}
              >
                <NumberInputField
                  label={<LocalizedMessage id="field.outsideVehicles" />}
                  min={0}
                  value={outsideQuantity}
                  sanitizer={sanitizeInt}
                  onChange={(value) => onFieldsChange({ outsideQuantity: value })}
                />
              </OnlyWith>
            </div>
          </div>
        </div>
        <OnlyWith
          permissions={{
            needed: customerWrite,
            permissionsOrContext: 'installationPermissions',
          }}
        >
          <div className="box-header box-dark d-flex justify-content-end p-2 right-spaced-buttons">
            <TextButton
              label={<LocalizedMessage id="button.cancel" />}
              size="small"
              disabled={!hasChanged}
              onClick={onResetForm}
            />
            <ContainedButton
              label={<LocalizedMessage id="button.update" />}
              size="small"
              disabled={!hasChanged}
              onClick={this.handleUpdate}
            />
            <ResetContainedButton size="small" context="warning" onClick={() => onReinit(customer)} />
          </div>
        </OnlyWith>
      </div>
    );
  }
}

CustomerStateForm.propTypes = {
  customer: customerDataShape.isRequired,
  updateError: errorShape,
  fields: PropTypes.object.isRequired,
  errors: PropTypes.object,
  onFieldsChange: PropTypes.func.isRequired,
  onResetForm: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onReinit: PropTypes.func.isRequired,
  handleDisplayMessage: PropTypes.func.isRequired,
};

CustomerStateForm.defaultProps = {
  updateError: null,
  errors: null,
};

const mapFieldsToProps = {
  insideQuantity: {
    resourceKey: 'state.inside_quantity',
    defaultValue: 0,
  },
  outsideQuantity: {
    resourceKey: 'state.outside_quantity',
    defaultValue: 0,
  },
};

const mapOwnPropsToResources = (ownProps) => ({
  resourceData: _get(ownProps, 'customer'),
});

const mapStateToProps = (state) => ({
  updateError: state.installationCustomer.updateState.error,
});

module.exports = compose(
  connect(
    mapStateToProps,
  ),
  withFormManagement(
    mapFieldsToProps,
    mapOwnPropsToResources,
  ),
  withMessageDialog,
)(CustomerStateForm);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/customers/CustomerStateForm.js